import { render } from "./P058.vue?vue&type=template&id=23955276&scoped=true"
import script from "./P058.vue?vue&type=script&lang=js"
export * from "./P058.vue?vue&type=script&lang=js"

import "./P058.vue?vue&type=style&index=0&id=23955276&scoped=true&lang=css"

import exportComponent from "/home/sage/workspace/sageprice-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23955276"]])

export default __exports__